import { AxiosPromise } from 'axios';
import { DismissalJointLiabilityMutationApplication } from '__generated__/api';
import { http } from '../http';

export const saveOhaMutation =
  () =>
  (
    mutation: DismissalJointLiabilityMutationApplication
  ): AxiosPromise<DismissalJointLiabilityMutationApplication> =>
    http({
      url: '/api/oha/save',
      method: 'POST',
      data: JSON.stringify(mutation),
    });

export const saveAndValidateOhaMutation = (
  mutation: DismissalJointLiabilityMutationApplication
): AxiosPromise<DismissalJointLiabilityMutationApplication> =>
  http({
    url: '/api/oha/saveAndValidate',
    method: 'POST',
    data: JSON.stringify(mutation),
  });

export const getOhaById = async (
  id: number
): Promise<DismissalJointLiabilityMutationApplication> => {
  try {
    const response = await http({
      url: `/api/oha/${id}`,
      method: 'GET',
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
